var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 14.8491,
    width: 21,
    height: 1,
    transform: "rotate(-45 1 14.8491)",
    fill: "#4800BD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 1,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1 0.70752)",
    fill: "#4800BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8a4e3455e87bd44051d0ed29771b1f16.svg";
export { ForwardRef as ReactComponent };